var legacySwappableCss = function legacySwappableCss(legacyCss, defaultCss) {
  return function (_ref) {
    var theme = _ref.theme;
    return theme.name === 'legacy' ? legacyCss : defaultCss;
  };
};

export default legacySwappableCss;